export const getRowConfig = (t, data = {}) => [
  {
    label: t('Workers'),
    render: () => <span>{data.workers || 0}</span>,
  },
  {
    label: t('Production'),
    render: () => (
      <>
        <span>{0}g</span>
        <span className="sm">/month</span>
      </>
    ),
  },
  {
    label: t('Community members'), 
    render: () => <span>{0}</span>,
  },
  {
    label: t('Investment'),
    render: () => <span>$ {0}</span>,
  },
]
